module.exports = __webpack_public_path__ + "2e91c7698cd82876c879cfd225384409.png";